// ./pages/Contact.js
import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaInstagram, FaTiktok, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

export default function Contact() {
  return (
    <div style={{ background: "linear-gradient(135deg, #f8f9fa, #e9ecef)", minHeight: "100vh", paddingTop: "60px", paddingBottom: "60px" }}>
      <Container>
        <h1 className="text-center mb-5">📞 Kontak Kami</h1>

        <Row className="g-4">
          {/* Info Kontak */}
          <Col xs={12} md={6}>
            <Card className="p-4 hover-card" style={{
              borderRadius: "12px",
              boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
              transition: "transform 0.2s",
            }}>
              <h4>Informasi Kontak</h4>
              <p><FaMapMarkerAlt /> <strong>Alamat:</strong> Gg. Nangka RT. 001 RW. 002 Karang Asem Timur, Kec. Citeureup, Kabupaten Bogor, Jawa Barat</p>
              <p><FaPhone /> <strong>Telepon:</strong> 021 8908 5323</p>
              <p><FaPhone /> <strong>Hp:</strong> 0857 7779 9560</p>

              <div className="d-flex gap-3 mt-3">
                <p><strong>Tiktok:</strong></p>
                <a href="https://www.tiktok.com/@paud.kb.cahaya.pi" target="_blank" rel="noopener noreferrer">
                  <FaTiktok size={28} />
                </a>
                <p><strong>Istagram:</strong></p>
                <a href="https://www.instagram.com/paudkb_cahayapiraditakaning" target="_blank" rel="noopener noreferrer">
                  <FaInstagram size={28} />
                </a>
              </div>

              <Button
                href="https://wa.me/6285777799560"
                target="_blank"
                rel="noopener noreferrer"
                variant="success"
                className="mt-4"
                style={{ borderRadius: "50px", padding: "0.5rem 2rem" }}
              >
                Hubungi via WhatsApp
              </Button>
            </Card>
          </Col>

          {/* Peta */}
          <Col xs={12} md={6}>
            <Card style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
            }}>
              <iframe
                title="Peta Lokasi PAUD KB Cahaya"
                src="https://maps.google.com/maps?q=PAUD%20KB%20Cahaya%20Piradita%20Kaning&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}